// extracted by mini-css-extract-plugin
export default {"key":"ycGyX","value":"Y6QQO","sidebar_history_copy":"WgPob"};